'use client';
import React, { useState, useEffect } from 'react';
import ShopProducts from '../../shop-product/components/ShopProducts';
import ShopSidebar from '../../shop-sidebar/components/ShopSidebar';
import ProductGridSkeleton from '@/style/scss/layout/product-grid-skeleton/ProductGridSkeleton';
import { useRouter, useSearchParams } from 'next/navigation';
import { BiFilterAlt } from 'react-icons/bi';
import axios from '@/lib/axios';
import { isAxiosError } from 'axios';
const Shop = (params: Record<string, string>) => {
  const [products, setProducts] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const router = useRouter();
  const searchParams = useSearchParams();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleSortChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newSort = e.target.value;
    const params = new URLSearchParams(searchParams.toString());

    newSort === 'default'
      ? params.delete('order_by')
      : params.set('order_by', newSort);

    router.push(`?${params.toString()}`);
  };

  const handlePerPageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newPerPage = e.target.value;
    const params = new URLSearchParams(searchParams.toString());
    params.set('per_page', newPerPage);
    router.push(`?${params.toString()}`);
  };

  useEffect(() => {
    const fetchProducts = async () => {
      setLoading(true);
      try {
        const res = await axios.post(
          `/api/v2/gigalogy/items/search`,
          {
            page: Number(params.page) || 1,
            type: params.type,
            search: params.search,
            category: params.category,
            min_price: params.min_price,
            max_price: params.max_price,
            skin_type: params.skin_type,
            per_page: Number(params.per_page) || 24,
            order_by: params.order_by,
            good_for: params.good_for,
            brand: params.brand,
          },
          {
            headers: { 'Content-Type': 'application/json' },
          }
        );
        setProducts(res.data);
      } catch (error) {
        if (isAxiosError(error)) {
          throw new Error('Failed to fetch products');
        }
        throw error;
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [params]);

  return (
    <>
      {/* Header component */}
      <section className="page-header pt-2 pt-lg-4">
        <div className="container">
          <div className="page-header__content">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-start mb-0">
                <li className="breadcrumb-item ">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Shop
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </section>
      <section className="product padding-bottom">
        <div className="container">
          <div className="product__wrapper">
            <div className="row justify-content-center flex-lg-row-reverse g-4">
              <div className="col-lg-9">
                <nav className="toolbox sticky-header mobile-sticky d-flex justify-content-between flex-wrap mb-4">
                  <div className="toolbox-left d-flex align-items-center gap-2 flex-wrap">
                    <button
                      onClick={() => setSidebarOpen(true)}
                      className="sidebar-toggle d-flex align-items-center gap-1 d-lg-none"
                    >
                      <BiFilterAlt />
                    </button>

                    <div className="toolbox-item toolbox-sort d-flex align-items-center gap-2">
                      <label className="d-none d-md-block">Sort By:</label>
                      <div className="select-custom">
                        <select
                          value={params.order_by || 'default'}
                          onChange={handleSortChange}
                          className="form-select py-1 px-2 mb-0"
                        >
                          <option value="default">Default</option>
                          <option value="bestseller">Best Selling</option>
                          <option value="rating">Rating</option>
                          <option value="new">Newest</option>
                          <option value="hot">Hot Deal</option>
                          <option value="price-asc">Price: low to high</option>
                          <option value="price-desc">Price: high to low</option>
                          <option className="d-none" value="l">
                            Price: high to low low
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div className="toolbox-right d-flex align-items-center gap-3 flex-wrap">
                    <div className="toolbox-item toolbox-show d-flex align-items-center gap-0 gap-md-3 mb-0">
                      <label className="d-none d-md-block">Show:</label>
                      <div className="select-custom">
                        <select
                          value={params.per_page || '24'}
                          onChange={handlePerPageChange}
                          className="form-select py-1 px-2 mb-0"
                        >
                          <option value="9">9</option>
                          <option value="12">12</option>
                          <option value="24">24</option>
                          <option value="36">36</option>
                          <option className="d-none">5555</option>
                        </select>
                      </div>
                    </div>

                    {/* <div className="toolbox-item layout-modes d-flex align-items-center gap-2">
                      <a
                        href="/shop"
                        className="layout-btn btn-grid active"
                        title="Grid"
                      >
                        <i className="icon-mode-grid" />
                      </a>
                      <a
                        href="/shop/list"
                        className="layout-btn btn-list"
                        title="List"
                      >
                        <i className="icon-mode-list" />
                      </a>
                    </div> */}
                  </div>
                </nav>

                <div className="row">
                  {loading ? (
                    <ProductGridSkeleton />
                  ) : (
                    <ShopProducts products={products || []} />
                  )}
                </div>
              </div>

              <div
                className={`col-lg-3 sidebar-col ${sidebarOpen ? 'sidebar-mobile-open' : ''}`}
              >
                <ShopSidebar
                  onClose={() => setSidebarOpen(false)}
                  isMobileOpen={sidebarOpen}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <div
        className={`sidebar-backdrop d-lg-none ${sidebarOpen ? 'active' : ''}`}
        onClick={() => setSidebarOpen(false)}
      />
    </>
  );
};

export default Shop;
